<template>
  <div v-loading ="isLoading">
    <button @click="deleteCustomers()" class="btn btn-danger btn-fill btn-wd">
      Deletar dados sensíveis de clientes
    </button>
    <el-progress :percentage="progressPercentage"></el-progress>
  </div>
</template>
<script>
  import Couchdb from 'src/services/Couchdb'
  import CouchdbClass from 'src/services/CouchdbClass'
  import LGPD from 'src/services/LGPD'
  // import swal from 'sweetalert2'
  import { mapActions } from 'vuex'

  export default {
    data () {
      return {
        isLoading: false,
        progress: 0,
        total: 0
      }
    },
    computed: {
      couchdbCustomers: function () {
        return new CouchdbClass({ connection: 'default', collection: 'customers' })
      },
      couchdbLamps: function () {
        return new CouchdbClass({ connection: 'default', collection: 'lamps' })
      },
      progressPercentage () {
        if (this.total === 0) {
          return 0
        }
        return parseInt((this.progress / this.total) * 100)
      }
    },
    methods: {
      ...mapActions('customers', {
        fetchCustomers: 'fetchAll',
        upsertCustomer: 'upsert'
      }),

      async deleteCustomers () {
        this.isLoading = true
        const contemplados = []

        let customers = await this.fetchCustomers({
          limit: 99999999
        })

        this.total = customers.length

        for (const customer of customers) {
          const lamps = await Couchdb.connection('default').collection('lamps').limit(99999999).where('customer.id', customer._id).get()

          for (const index in lamps) {
            const { holder } = lamps[index].customer

            lamps[index].customer.holder = holder.substring(0, 3) + '**********' + holder.substring(holder.length - 3, holder.length)

            delete lamps[index].customer.cpf
          }

          await this.couchdbLamps._updateBulkDocs(lamps)

          if (customer.contemplated) {
            const novosDadosDoContemplado = LGPD.removeCustomerSensitiveData(customer)

            contemplados.push(novosDadosDoContemplado)
            continue
          }

          await Couchdb.connection('default').delete(customer._id)
        }

        await this.couchdbCustomers._updateBulkDocs(contemplados)
        this.isLoading = false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/commands/DeleteLosers.vue